import FolderSharedRounded from '@mui/icons-material/FolderSharedRounded';
import GridOnRounded from '@mui/icons-material/GridOnRounded';
import InboxRounded from '@mui/icons-material/InboxRounded';
import LocalShippingRounded from '@mui/icons-material/LocalShippingRounded';
import MarkunreadMailboxRounded from '@mui/icons-material/MarkunreadMailboxRounded';
import PinDropRounded from '@mui/icons-material/PinDropRounded';

import { Workflow } from '@apiContract';
import { ReceiveToggleButtonGroupConfig } from 'src/types/shared';

const getLockerTooltip = (isAssigned?: boolean, isBarcoded?: boolean) => {
  switch (true) {
    case !isAssigned && !isBarcoded:
      return 'Waiting for unique tracking number and to be assigned';

    case !isAssigned:
      return 'Waiting to be assigned';

    case !isBarcoded:
      return 'Waiting for unique tracking number';

    default:
      return;
  }
};

export const workflowMailOptions = (
  disabled?: { [key in Workflow]?: string } | string,
): ReceiveToggleButtonGroupConfig<Workflow>[] => [
  {
    value: Workflow.DateReceived,
    label: 'Date received',
    Icon: InboxRounded,
    disabled: !!disabled?.[Workflow.DateReceived],
    tooltip: disabled?.[Workflow.DateReceived],
  },
  {
    value: Workflow.HighDensityMail,
    label: 'High density mail',
    Icon: FolderSharedRounded,
    disabled: !!disabled?.[Workflow.HighDensityMail],
    tooltip: disabled?.[Workflow.HighDensityMail],
  },
  {
    value: Workflow.MailBox,
    label: 'Mailbox',
    Icon: MarkunreadMailboxRounded,
    disabled: !!disabled?.[Workflow.MailBox],
    tooltip: disabled?.[Workflow.MailBox],
  },
];

export const workflowPackagesOptions = (
  lockersAvailable: boolean = false,
  currentPieceWorkflow?: Workflow,
  isAssigned?: boolean,
  isBarcoded?: boolean,
): ReceiveToggleButtonGroupConfig<Workflow>[] => {
  const isDisabledLocker =
    currentPieceWorkflow !== Workflow.Lockers &&
    ((isAssigned !== undefined && !isAssigned) || (isBarcoded !== undefined && !isBarcoded));
  const config: ReceiveToggleButtonGroupConfig<Workflow>[] = [
    {
      value: Workflow.Location,
      label: 'Location',
      Icon: PinDropRounded,
    },
    {
      value: Workflow.Carrier,
      label: 'Carrier',
      Icon: LocalShippingRounded,
    },
  ];
  if (lockersAvailable) {
    config.push({
      value: Workflow.Lockers,
      label: 'Lockers',
      Icon: GridOnRounded,
      disabled: isDisabledLocker,
      tooltip: getLockerTooltip(isAssigned, isBarcoded),
    });
  }
  return config;
};
